import config from "../config";
import { getTransformedElement } from "./getTransformedElement";

export const getDragBound = ({
  pos,
  element,
  currentShape,
  canvasTop,
  canvasLeft,
  canvasRight,
  canvasBottom,
  canvasOffsetX,
  canvasOffsetY,
  maxX,
  maxY,
  tileGap,
}) => {
  const defaultRatio = config.defaultRatio;
  const gap = config.defaultCanvasGap / defaultRatio + tileGap / defaultRatio;
  let minX = gap;
  let minY = gap;
  let x = pos.x;
  let y = pos.y;
  const { offsetX, offsetY, width, height } = getTransformedElement(element);

  if (currentShape === "simple") {
    maxX = canvasTop - width;
    maxY = canvasLeft - height;
  }

  if (currentShape === "left") {
    maxX = canvasTop - width;
    maxY = canvasRight - height;

    if (
      element.x() + offsetX - gap <= canvasBottom &&
      element.y() + offsetY + gap >= canvasRight
    ) {
      maxX = canvasBottom - width;
      maxY = canvasLeft - height;
    }
  }

  if (currentShape === "right") {
    minX = gap;

    maxX = canvasTop - width;
    maxY = canvasLeft - height;
    if (
      element.x() + offsetX - gap >= canvasBottom &&
      element.y() + offsetY + gap >= canvasLeft
    ) {
      minX = canvasBottom + gap;
      maxY = canvasRight - height;
      maxX = canvasTop - width;
    }
  }

  const limitedX = Math.max(
    minX + offsetX + canvasOffsetX,
    Math.min(maxX - gap + offsetX + canvasOffsetX, x)
  );
  const limitedY = Math.max(
    minY + offsetY + canvasOffsetY,
    Math.min(maxY - gap + offsetY + canvasOffsetY, y)
  );

  return {
    x: limitedX,
    y: limitedY,
  };
};
